export default __webpack_public_path__ + "static/facts-listings-4607f5d4d663b40628e1cbe4eb46bc4a.webp";